import { defineMessages } from 'react-intl';

export default defineMessages({
    paymentComponentBuyNow: {
        id: 'PEcpmiportal.integration.quoteandbind.directives.custom-quote.BOP.BuyNow',
        defaultMessage: 'BuyNow'
    },
    paymentSource: {
        id: 'PEcpmiportal.amp.bc3.directives.templates.payment-instrument-bc3.Source',
        defaultMessage: 'Source'
    },
    bankAccountSource: {
        id: 'PEcpmiportal.amp.bc3.directives.templates.payment-instrument-bc3.Bank Account',
        defaultMessage: 'Bank Account'
    },
    cardIssuer: {
        id: 'PEcpmiportal.platform.paymentdetails.credit-card-auto-details.Card Issuer',
        defaultMessage: 'Card Issuer',
    },
    selectIssuer: {
        id: 'PEcpmiportal.platform.paymentdetails.credit-card-auto-details.-- Please Select --',
        defaultMessage: '-- Please Select --'
    },
    paymentMethod: {
        id: 'PEcpmiportal.quoteandbind.views.payment-details.Payment Method',
        defaultMessage: 'Set Payment Source',
    },
    bankAccount: {
        id: 'PEcpmiportal.quoteandbind.views.payment-details.Bank Account',
        defaultMessage: 'Bank Account',
    },
    creditCard: {
        id: 'PEcpmiportal.quoteandbind.views.payment-details.Credit Card',
        defaultMessage: 'Credit Card',
    },
    accountType: {
        id: 'PEcpmiportal.quoteandbind.directives.templates.bank-account-details-quote.Account Type',
        defaultMessage: 'Account Type',
    },
    howToPay: {
        id: 'PEcpmiportal.quoteandbind.directives.templates.bank-account-details-quote.How do you want to pay?',
        defaultMessage: 'How do you want to pay?',
    },
    accountNumber: {
        id: 'PEcpmiportal.quoteandbind.directives.templates.bank-account-details-quote.Account Number',
        defaultMessage: 'Account Number',
    },
    routingNumber: {
        id: 'PEcpmiportal.quoteandbind.directives.templates.bank-account-details-quote.Routing (ABA) Number',
        defaultMessage: 'Routing (ABA) Number',
    },
    bankName: {
        id: 'PEcpmiportal.quoteandbind.directives.templates.bank-account-details-quote.Bank Name',
        defaultMessage: 'Bank Name',
    },
    cancel: {
        id: 'PEcpmiportal.platform.paymentdetails.Cancel',
        defaultMessage: 'Cancel',
    },
    termandConditionsheader:{
        id:'PEcpmiportal.platform.paymentdetails.Terms and Conditions',
        defaultMessage:'Terms and Conditions'
    },
});
